import React, { memo, useState, useEffect, Fragment } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import ReactTable from 'components/ReactTable/ReactTable';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 90 },
  { Header: 'Fecha deposito', accessor: 'TaxDate', width: 150 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 100 },
  { Header: 'Cuenta', accessor: 'account', width: 150 },
  { Header: 'Descripción', accessor: 'description_operation', width: 230 },
  { Header: 'Monto', accessor: 'amount', width: 170 },
  { Header: 'Operación', accessor: 'operation', width: 120 },
  { Header: 'Referencia', accessor: 'ref2' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
export default WithApp(function ModalOpe(props) {
  const classes = useStyles();
  const { importDataOperation=[] } = props;
  return (
    <Modal
      title="Validación de depositos con documentos de extracto bancario"
      model={{ open: props.open }}
      setOpen={props.onClose}
      showNotify={props.showNotify}
      hideSave
      arrDataResponse
    >
      <ReactTable
        defaultWidth={1500}
        columns={columns}
        exportExcel={false}
        formatDate="DD-MM-YYYY"
        data={importDataOperation.map((item, i) => {
          return {
            ...item,
            num: (
              <div className="actions-right">
                {i + 1}
              </div>
            ),
            TaxDate: item.TaxDate,
            base_zone_description: item.base_zone_description,
            account: item.account,
            description_operation: item.description_operation,
            amount: item.amount,
            operation: item.operation,
            ref2: item.ref2,
          };
        })}
      />
    </Modal>
  );
});

